import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { globalActions, useStore } from '@modules';

import { useCustomContext } from '../../context';
import SearchInput from '../SearchInput';

import style from './PurposeOfPayment.scss';

const cn = bemCssModules(style, 'PurposeOfPayment');
const ti = getTestId('PurposeOfPayment');

export const PurposeOfPayment: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [, dispatch] = useStore();
  const [data, setData] = useState<string[]>([]);
  const { context, setContext } = useCustomContext();
  const { purpose } = context;

  useEffect(() => {
    dispatch(globalActions.getIbanPurposes())
      .unwrap()
      .then(res => {
        const formated = res.data.map(obj => obj.name);
        setData(formated);
      });
  }, []);

  return (
    <SearchInput
      className={cn(null, [className])}
      data-testid={ti()}
      label={t('sepa.purpose_of_payment')}
      placeholder={t('sepa.select_purpose_of_payment_placeholder')}
      data={data}
      dropdownClassName={cn('dropdown')}
      onInput={value => {
        setContext(draft => {
          draft.purpose = value;
        });
      }}
      outerValue={purpose}
    />
  );
};

export default PurposeOfPayment;
